import { Box, Card, Flex, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"
import moment from "moment"
import { FC } from "react"
import BuildStatusTag from "src/components/shared/BuildStatusTag"
import { IosBuild } from "../../../../domain/entities/iosBuild"
import { DeleteIconButton } from "../../../ui/iconButtons/DeleteIconButton"
import { EditIconButton } from "../../../ui/iconButtons/EditIconButton"

export const IosBuildListView: FC<{
	list: IosBuild[]
	onUpdate: (iosBuild: IosBuild) => void
	onDelete: (iosBuild: IosBuild) => void
}> = ({ list, onUpdate, onDelete }) => (
	<>
		<Table size={"sm"} display={{ base: "none", lg: "table" }}>
			<Thead>
				<Tr>
					<Th>Build No.</Th>
					<Th>Version</Th>
					<Th>Status</Th>
					<Th>Publish date</Th>
					<Th isNumeric>Actions</Th>
				</Tr>
			</Thead>
			<Tbody>
				{list.map((iosBuild, i) => (
					<Tr key={i}>
						<Td>{iosBuild.buildNo}</Td>
						<Td>{iosBuild.version}</Td>
						<Td>
							<BuildStatusTag status={iosBuild.status} />
						</Td>
						<Td>{moment(iosBuild.publishDate).format("DD/MM/YYYY")}</Td>
						<Td isNumeric>
							<EditIconButton onClick={() => onUpdate(iosBuild)} />
							<DeleteIconButton onClick={() => onDelete(iosBuild)} />
						</Td>
					</Tr>
				))}
			</Tbody>
		</Table>

		{list.map((iosBuild, i) => {
			return (
				<Card
					key={i}
					display={{ base: "flex", lg: "none" }}
					shadow={"md"}
					m={"2"}
				>
					<Box display={"flex"} justifyContent={"space-between"} m={"2"}>
						<Box alignItems={"center"}>
							<Flex align={"center"}>
								<Box fontWeight={"semibold"}>Build No:</Box>
								<Box ml={"2"} fontSize={"sm"}>
									{iosBuild.buildNo}
								</Box>
							</Flex>
							<Flex align={"center"}>
								<Box fontWeight={"semibold"}>Version:</Box>
								<Box ml={"2"} fontSize={"sm"}>
									{iosBuild.version}
								</Box>
							</Flex>
							<Flex align={"center"} my={"1"}>
								<Box fontWeight={"semibold"}>Status:</Box>
								<Box ml={"2"}>
									<BuildStatusTag status={iosBuild.status} />
								</Box>
							</Flex>
							<Flex align={"center"}>
								<Box fontWeight={"semibold"}>Publish Date:</Box>
								<Box ml={"2"} fontSize={"sm"}>
									{moment(iosBuild.publishDate).format("DD/MM/YYYY")}
								</Box>
							</Flex>
						</Box>
						<Box>
							<EditIconButton onClick={() => onUpdate(iosBuild)} />
							<DeleteIconButton onClick={() => onDelete(iosBuild)} />
						</Box>
					</Box>
				</Card>
			)
		})}
	</>
)
